import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Bidirectional amount × months helper.
 * - When the user types an amount, the months field updates (amount / prix).
 * - When the user types months, the amount field updates (months × prix).
 * The component does not store its own state — it lifts changes via onChange.
 */
export default function AmountMonthsInput({
  label,
  amountLabel = "FCFA",
  prix = 0,
  value = 0,
  onChange,
  amountTestid,
  monthsTestid,
  helpText,
  disableMonths = false,
}) {
  const numericPrix = Number(prix || 0);
  const numericValue = Number(value || 0);
  const monthsRaw = numericPrix > 0 ? numericValue / numericPrix : 0;
  // Show up to 2 decimals but trim trailing zeros for clean display
  const monthsValue =
    !disableMonths && numericValue && numericPrix
      ? String(Number(monthsRaw.toFixed(2))).replace(/\.0+$/, "")
      : "";

  return (
    <div>
      <Label className="mb-2 block">{label}</Label>
      <div className="grid grid-cols-[1fr_130px] gap-2">
        <div className="space-y-1">
          <Input
            type="number"
            min="0"
            value={value}
            onChange={(e) => onChange(Number(e.target.value || 0))}
            data-testid={amountTestid}
            placeholder="0"
          />
          <span className="text-[11px] text-slate-500 block">{amountLabel}</span>
        </div>
        <div className="space-y-1">
          <Input
            type="number"
            min="0"
            step="0.5"
            value={monthsValue}
            onChange={(e) => {
              const m = Number(e.target.value || 0);
              onChange(m * numericPrix);
            }}
            disabled={disableMonths || !numericPrix}
            placeholder={disableMonths ? "—" : numericPrix ? "0" : "—"}
            data-testid={monthsTestid}
          />
          <span className="text-[11px] text-slate-500 block">Nombre de mois</span>
        </div>
      </div>
      {helpText && <p className="text-[11px] text-slate-500 mt-1.5">{helpText}</p>}
      {disableMonths ? (
        <p className="text-[11px] text-amber-600 mt-1">
          Locataire temporaire : le calcul par mois est désactivé.
        </p>
      ) : !numericPrix ? (
        <p className="text-[11px] text-amber-600 mt-1">
          Renseignez d'abord le loyer convenu pour activer le calcul par mois.
        </p>
      ) : null}
    </div>
  );
}
